import { Phone, MessageCircle, X } from 'lucide-react';
import { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

export const StickyCTA = () => {
  const [isVisible, setIsVisible] = useState(true);
  const phoneNumber = '+917020970161';
  const whatsappNumber = '917020970161';

  if (!isVisible) return null;

  return (
    <AnimatePresence>
      <motion.div
        initial={{ y: 100, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        exit={{ y: 100, opacity: 0 }}
        transition={{ duration: 0.5, delay: 1 }}
        className="fixed bottom-0 left-0 right-0 z-40 bg-gradient-to-r from-rose-gold to-rose-dark shadow-2xl border-t-2 border-rose-gold/50"
      >
        <div className="px-4 py-4 flex items-center justify-between gap-4 max-w-7xl mx-auto">
          <div className="hidden md:block">
            <p className="text-white font-heading text-lg font-bold">Ready to Find Your Dream Property?</p>
            <p className="text-white/80 text-sm">Get best prices • Free site visits • Expert guidance</p>
          </div>
          
          <div className="flex items-center gap-3 flex-1 md:flex-initial justify-center">
            <a
              href={`tel:${phoneNumber}`}
              data-testid="sticky-call-button"
              className="flex-1 md:flex-initial bg-white text-rose-gold px-6 md:px-8 py-4 rounded-full font-bold hover:bg-rose-light hover:text-white transition-all shadow-lg hover:scale-105 flex items-center justify-center gap-2 text-sm md:text-base uppercase tracking-wider"
            >
              <Phone size={20} className="animate-pulse" />
              <span>Call Now</span>
            </a>
            
            <a
              href={`https://wa.me/${whatsappNumber}?text=${encodeURIComponent('Hi, I want to know more about properties')}`}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="sticky-whatsapp-button"
              className="flex-1 md:flex-initial bg-green-500 text-white px-6 md:px-8 py-4 rounded-full font-bold hover:bg-green-600 transition-all shadow-lg hover:scale-105 flex items-center justify-center gap-2 text-sm md:text-base uppercase tracking-wider"
            >
              <MessageCircle size={20} className="animate-pulse" />
              <span>WhatsApp</span>
            </a>
          </div>

          <button
            onClick={() => setIsVisible(false)}
            className="hidden md:block text-white/60 hover:text-white transition-colors"
            aria-label="Close"
          >
            <X size={20} />
          </button>
        </div>

        {/* Urgency Banner */}
        <div className="bg-yellow-500 text-black text-center py-2 text-xs md:text-sm font-bold uppercase tracking-wider">
          ⚡ Limited Units Available • Best Prices Guaranteed • Free Site Visit ⚡
        </div>
      </motion.div>
    </AnimatePresence>
  );
};

export default StickyCTA;
